import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";

export interface UseArticulosParams {
	idsFamilia: string[];
	idsSubFamilia: string[];
}
export function useArticulos(_parametros: UseArticulosParams) {
	const parametros = {
		..._parametros,
		tipo: "todo",
		skipNoUsar: true,
	};
	return useQuery<ArticuloFabricacion[]>({
		queryKey: ["getArticulosStock", parametros],
		queryFn: () => {
			return sendAjaxRequest<ArticuloFabricacion[]>("GET", "/api/v1/getArticulosStock", parametros);
		}
	});
}
export interface ArticuloFabricacion {
	idArticulo: string;
	nombreArticulo: string;
	nombreFamilia: string | null;
	nombreSubFamilia: string | null;
	rutaFabricacion: string | null;
	tipoArticulo: number | null;

	stock: number | null;
	pendienteEntrada: number | null;
	pendienteSalida: number | null;
	entrarRecomendado: number;
	max: number | null;
	min: number | null;
}
export type TiposSeleccionFiltroStock = [
	"todo",
	"enStock",
	"minimo",
	"minimo-request",
	"maximo",
	"roturaStock",
	"roturaStock-request",
][number];